
import { Component, Vue } from 'vue-property-decorator'
import CheckoutModal from '../../modules/order/CheckoutModal.vue'
import FooterLayout from '../homepage/Footer.vue'
import CategoryHeader from '../../modules/headers/CategoryHeader.vue'
import UserDropdown from '../../modules/user/UserDropdown.vue'
import Cart from '../../modules/Cart.vue'
import SearchHeader from '../../modules/headers/SearchHeader.vue'
import UserModule from '../../modules/headers/UserModule.vue'
import EmojiFeedback from '@/modules/feedback/EmojiFeedback.vue'
import TextFeedback from '@/modules/feedback/TextFeedback.vue'
import BusinessCard from '@/modules/order/BusinessCard.vue'
import eventBus from '@/plugins/eventBus'

@Component({
  components: {
    BusinessCard,
    EmojiFeedback,
    UserModule,
    SearchHeader,
    Cart,
    UserDropdown,
    CategoryHeader,
    FooterLayout,
    CheckoutModal,
    TextFeedback,
  },
})
export default class feedback extends Vue {
  feedbackReceived = false
  feedbackResponse = ''

  updateFeedback(id) {
    this.feedbackReceived = !this.feedbackReceived
    this.feedbackResponse = id
  }

  mounted() {
    eventBus.$on('feedback-received', (id: any) => {
      this.updateFeedback(id)
    })
  }
}
